import {IconProps} from "./types";

export default function ArrowDownIcon({width=20,height=21,color="black",...props}:IconProps) {
    return <svg width={width} height={height} viewBox="0 0 20 21" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path d="M5 7.5L9.29289 11.7929C9.68342 12.1834 10.3166 12.1834 10.7071 11.7929L15 7.5" stroke={color}
              strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

}